import io from 'socket.io-client';
import axios from 'axios';

const SERVER_URL = 'https://thought-classifier-571429268886.us-central1.run.app';
const BASE_API_URL = SERVER_URL.replace(/\/$/, '').replace(/\/thoughts$/, '');
const API_URL = `${BASE_API_URL}/thoughts`;

export const socket = io(BASE_API_URL, {
    transports: ["websocket", "polling"], 
    upgrade: true
});

export const api = axios.create({ baseURL: API_URL });
export const ENDPOINT = API_URL;